import { render, staticRenderFns } from "./process-remind-modal.vue?vue&type=template&id=2ae753eb&"
import script from "./process-remind-modal.vue?vue&type=script&lang=js&"
export * from "./process-remind-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports